import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, successMessage: String }

  copy() {
    const el = Object.assign(document.createElement("textarea"), { value: this.textValue })
    el.style.position = "fixed"
    el.style.opacity = "0"
    this.element.appendChild(el)
    el.select()
    document.execCommand("copy")
    el.remove()
    this.showSuccess()
  }

  showSuccess() {
    if (this.successMessageValue) {
      toastHandler.showToast("success", this.successMessageValue)
    }
  }
}
